import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import { LandingPage } from '../pages/LandingPage';

export const RedirectComponent: React.FC = () => {
  const { isAuthenticated, authInitialized } = useUser();
  
  if (!authInitialized) {
    // Show loading while authentication is being determined
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-b from-purple-950 to-[#1a0530] relative overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-center opacity-5">
          <img
            src="/TSL_Logo.png"
            alt="Logo"
            className="w-[600px] h-[600px] object-contain"
          />
        </div>
        <div className="relative z-10 animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-violet-400"></div>
      </div>
    );
  }

  // If authenticated, redirect to dashboard
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  // If not authenticated, show landing page
  return <LandingPage />;
};